import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import ServicesSection from "./components/ServicesSection";
import VisaSection from "./components/VisaSection";
import ProductsSection from "./components/ProductsSection";
import CatalogSection from "./components/CatalogSection";
import AboutSection from "./components/AboutSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";

const HomePage = () => (
  <>
    <Navbar />
    <main>
      <HeroSection />
      <ServicesSection />
      <VisaSection />
      <ProductsSection />
      <CatalogSection />
      <AboutSection />
      <ContactSection />
    </main>
    <Footer />
    <WhatsAppButton />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
